import React from 'react'
import { Box, Chip } from '@mui/material'
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment'
import FiberNewIcon from '@mui/icons-material/FiberNew'
import SpaIcon from '@mui/icons-material/Spa'
import GrassIcon from '@mui/icons-material/Grass'
import NoMealsIcon from '@mui/icons-material/NoMeals'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import CheckRoundedIcon from '@mui/icons-material/CheckRounded'
import { useTranslation } from 'react-i18next'
import { mw } from '../../views/menuWorkspaceStyles'

const TAG_CONFIG = [
  { key: 'Spicy', icon: LocalFireDepartmentIcon },
  { key: 'New', icon: FiberNewIcon },
  { key: 'Vegetarian', icon: SpaIcon },
  { key: 'Vegan', icon: GrassIcon },
  { key: 'Gluten-Free', icon: NoMealsIcon },
  { key: 'Halal', icon: CheckCircleOutlineIcon },
  { key: 'Kosher', icon: CheckCircleOutlineIcon },
  { key: 'Dairy-Free', icon: NoMealsIcon },
  { key: 'Organic', icon: SpaIcon },
  { key: 'Keto', icon: CheckCircleOutlineIcon },
  { key: 'Paleo', icon: CheckCircleOutlineIcon },
  { key: 'Sugar-Free', icon: NoMealsIcon },
  { key: 'Nut-Free', icon: NoMealsIcon }
]

const DietaryTagChips = ({ selectedTags, onChange }) => {
  const { t } = useTranslation()

  const handleToggle = (tag) => {
    if (selectedTags.includes(tag)) {
      onChange(selectedTags.filter(t => t !== tag))
    } else {
      onChange([...selectedTags, tag])
    }
  }

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {/* Pill toggles: selected = solid green with a check. */}
      {TAG_CONFIG.map(({ key, icon: Icon }) => {
        const selected = selectedTags.includes(key)
        return (
          <Chip
            key={key}
            label={t(key)}
            icon={selected
              ? <CheckRoundedIcon fontSize="small" sx={{ color: '#fff' }} />
              : <Icon fontSize="small" sx={{ color: mw.color.textMuted }} />}
            clickable
            variant={selected ? 'filled' : 'outlined'}
            color={selected ? 'primary' : 'default'}
            onClick={() => handleToggle(key)}
            size="small"
            sx={{
              height: 34,
              px: 0.5,
              borderRadius: mw.radius.pill,
              fontSize: 13.5,
              fontWeight: 600,
              color: selected ? '#fff' : mw.color.textSecondary,
              bgcolor: selected ? mw.color.on : mw.color.cardBg,
              border: '1px solid',
              borderColor: selected ? mw.color.on : mw.color.border,
              transition: 'background-color .15s ease, border-color .15s ease, color .15s ease',
              '& .MuiChip-icon': { fontSize: 17, ml: '6px' },
              '&:hover': selected
                ? { bgcolor: '#267A42', borderColor: '#267A42' }
                : { bgcolor: mw.color.headBg, borderColor: mw.color.borderStrong },
              '&.MuiChip-clickable:hover': { bgcolor: selected ? '#267A42' : mw.color.headBg }
            }}
          />
        )
      })}
    </Box>
  )
}

export default DietaryTagChips
